/**
 * @generated SignedSource<<d7e7fd4b65b8a328c4ed046f7a65195e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WalletSelectorFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DeprecatedWalletSelectorFragment" | "MultichainWalletSelectorFragment">;
  readonly " $fragmentType": "WalletSelectorFragment";
};
export type WalletSelectorFragment$key = {
  readonly " $data"?: WalletSelectorFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WalletSelectorFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WalletSelectorFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeprecatedWalletSelectorFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultichainWalletSelectorFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1aafe417817ace4438f93a66ba423e66";

export default node;
